import React from "react";

export default function Header() {
  return <header>
    <h2>Cooking Inspirations</h2>
  </header>;
}
